import { UserAgentSupport } from '../../common/utilities/UserAgentSupport';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { WindowLocationService } from './WindowLocationService';

export class MobileAppService {

  public static $inject = [
    '$translate',
    '$cookies',
    'WindowLocationService'
  ];

  constructor(private $translate: ng.translate.ITranslateService,
              private $cookies: ng.cookies.ICookiesService,
              private windowLocationService: WindowLocationService)
    {}

  public readonly HIDE_APP_BANNER_COOKIE = 'hideAppBanner';

  public shouldShowAppBanner(disableAppBannerFlag: boolean) {
    return !disableAppBannerFlag                          // Will be used by mobile app for web auth
     && FeatureFlags.customAppBanner                      // Feature flag
     && (UserAgentSupport.isMobileBrowser() || this.isIpadInDesktopMode()) // Mobile browsers only (and special case for ipad os)
     && this.$cookies.get(this.HIDE_APP_BANNER_COOKIE) == null;            // Banner has been dismissed in the past 7 days.
  }

  public createDeepLink(redirect: string, externalRedirect: string) {
    // Create the deeplink. It is
    // tableau://[url to which we are supposed to get redirected]
    // If there is no redirect url, then just use "tableau://[current url]"
    let deepLink = null;
    if (externalRedirect) {
      deepLink = 'tableau://' + this.windowLocationService.getHost() + externalRedirect;
    } else {
      const protocol = this.windowLocationService.getProtocol();
      deepLink = this.windowLocationService.getHref();
      deepLink = deepLink.replace(protocol, 'tableau:');
      if (redirect) {
        deepLink = deepLink.split('#')[0] + '#' + redirect;
      }
    }
    return deepLink;
  }

  private isTouchEnabled() {
    return !!('ontouchstart' in window);
  }

  // TFSID 940092 - As of iOS 13, Safari on iPads will impersonate a desktop browser by default.
  // This makes it impossible to detect iPads by user agent alone. To get around this we infer 
  // iPads in desktop browser mode by checking for a Macintosh user agent string and
  // and touch support. 
  private isIpadInDesktopMode() {
    // TFSID:960184 We also have to check that the request is not coming from a tableau application
    // since the webview on a tableau desktop (mac) used for authentication can meet the first two
    // conditionals. They have touch events due to it using QWebView. So we exclude this case by
    // making sure "Tableau" is not in the user agent string
    return this.isTouchEnabled() && UserAgentSupport.isSafariOnMac() && !UserAgentSupport.isTableau();
  }

  public maybeRedirectToApp(deepLink: string) {
    // This will trigger the browser to open the app if it's installed.
    (window as any).location = deepLink;

    // We redirect to the app store. This is delayed to give the browser a chance to
    // redirect to the app store.
    setTimeout(() => {
      if (UserAgentSupport.isIOS()){
        // This additional dialogue is necessary for iOS because iOS prompts a native dialogue
        // to open the app. Without the dialogue below, the browser will redirect to the app store
        // before the user is able to respond to the native dialogue. The dialogue below will show up
        // behind the native dialogue - this unusual behavior is expected.
        if (confirm(this.$translate.instant('redirectToAppStore'))){
          (window as any).location = 'https://itunes.apple.com/app/tableau-mobile/id434633927';
        }
      } else if (UserAgentSupport.isAndroid()){
        (window as any).location = 'https://play.google.com/store/apps/details?id=com.Tableau.TableauApp';
      }
    }, 1000);
  }
}

Module.instance().service('MobileAppService', MobileAppService);
